export const isFetching = (state: any) => {
    return state.isFetching;
}

export const allMappings = (state: any) => {
    return state.allMappings;
}

export const allCategories = (state: any) => {
    return state.allCategories;
}
